<template>
  <sistema>
    <div>
      <crud-tabela-preco
        :isSearch="false"
        :isNew="isNew"
        :idTabelaPreco="idTabelaPreco"
      />
    </div>
  </sistema>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import CrudTabelaPreco from "../../components/orcamento/CrudTabelaPreco.vue";

@Options({
  props: {
    isNew: Boolean,
    idTabelaPreco: Number
  },
  components: {
    CrudTabelaPreco
  }
})
export default class TabelaPreco extends Vue {
  isNew?: boolean;
  idTabelaPreco?: number;
}
</script>

<style scoped lang="scss"></style>
